<template>
  <div id="ExtensionsSelect" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">C</span>aja</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(ext,ext_i) in data_list" v-bind:key="ext_i" @click="set_ext_args(ext_i)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-12 pl10">
                <div class="col-2 pt10"><i class="iconfont icon-diannao color-primary f30"></i></div>
                <div class="col-8 f14 uppercase pb2 el1 pt2">
                  <div class="color-muted col-12">ID: {{ ext.extension_code }}</div>
                  <div class="col-12">{{ ext.extension_name }}</div>
                </div>
                <div class="col-2 t-r pt10"><i class="iconfont f18" :class="$store.state.app_args.extension_code == ext.extension_code ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExtensionsSelect',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      this.post(this.api_url + 'manage/extensions_select', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.extensions;
        }else{
          this.data_list = []
        }
      })
    },
    set_ext_args(i){
      let extension_code = this.data_list[i].extension_code;
      let extension_name = this.data_list[i].extension_name;
      this.$store.commit('setAppArgs',{extension_code: extension_code, extension_name: extension_name});
      this.$router.back(-1);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/ExtensionsSelect.vue